/* The loading, empty, error and not-applicable states every Power Admin screen shares. */

.admin-state-visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
  border: 0;
}

/* Loading ---------------------------------------------------------------------------------- */

.admin-state-loading {
  display: grid;
  gap: 10px;
}

.admin-state-loading-row {
  display: block;
}

.admin-state-skeleton-tiles {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px;
}

.admin-state-skeleton-block {
  display: block;
  border-radius: var(--radius-finnest-control);
  background: linear-gradient(
    90deg,
    var(--color-finnest-muted-surface) 0,
    var(--color-finnest-canvas) 50%,
    var(--color-finnest-muted-surface) 100%
  );
  background-size: 200% 100%;
  animation: admin-state-shimmer 1.2s linear infinite;
}

.admin-state-skeleton-tile {
  height: 92px;
}

.admin-state-skeleton-line {
  height: 42px;
}

.admin-state-skeleton-bar {
  width: min(240px, 100%);
  height: 14px;
}

@keyframes admin-state-shimmer {
  from {
    background-position: 200% 0;
  }

  to {
    background-position: -200% 0;
  }
}

@media (prefers-reduced-motion: reduce) {
  .admin-state-skeleton-block {
    animation: none;
  }
}

@media (max-width: 720px) {
  .admin-state-skeleton-tiles {
    grid-template-columns: minmax(0, 1fr);
  }
}

/* Empty and not applicable ------------------------------------------------------------------ */

.admin-state-empty {
  display: grid;
  justify-items: center;
  gap: 8px;
  border: 1px dashed var(--color-finnest-border);
  border-radius: var(--radius-finnest-control);
  background: var(--color-finnest-surface);
  padding: 40px 24px;
  color: var(--color-finnest-ink);
  text-align: center;
}

.admin-state-empty-icon {
  display: inline-flex;
  width: 44px;
  height: 44px;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  background: var(--color-finnest-accent-soft);
  color: var(--color-finnest-accent);
}

.admin-state-empty-text {
  max-width: 460px;
  margin: 0;
  color: var(--color-finnest-muted);
  line-height: 1.45;
}

.admin-state-final-reference {
  margin-top: 8px;
}

/* Error and stale data ----------------------------------------------------------------------- */

.admin-state-error,
.admin-state-stale {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 14px;
  border: 1px solid color-mix(in srgb, var(--color-finnest-danger) 26%, transparent);
  border-radius: var(--radius-finnest-control);
  background: color-mix(in srgb, var(--color-finnest-danger) 7%, var(--color-finnest-surface));
  color: var(--color-finnest-ink);
  line-height: 1.45;
}

.admin-state-error {
  padding: 16px 18px;
}

.admin-state-stale {
  padding: 10px 14px;
  font-size: 13px;
}

.admin-state-error > svg {
  flex: none;
  color: var(--color-finnest-danger);
}

.admin-state-message {
  display: grid;
  flex: 1;
  gap: 2px;
  min-width: min(260px, 100%);
}

.admin-state-error strong {
  color: var(--color-finnest-danger);
}

.admin-state-message p {
  margin: 0;
  font-size: 13px;
}

.admin-state-support {
  display: block;
  color: var(--color-finnest-muted);
  font-size: 13px;
}

.admin-state-support code {
  color: var(--color-finnest-ink);
  overflow-wrap: anywhere;
}

.admin-state-support a {
  display: inline-block;
  margin-top: 4px;
  color: var(--color-finnest-accent);
}
